import Parallax from "parallax-js";
import { CLASSES } from "@/scripts/helpers/constants";
import { checkWebpSupport } from "@/scripts/helpers/library";
import { initWowLibrary } from "@/scripts/helpers/wowAnimation";
import { addedLazyLoadImages } from "@/scripts/helpers/imgLazyload";

const initParallaxDecorations = scene => {
  const parallaxInstance = new Parallax(scene[0], {
    pointerEvents: false,
    invertX: false,
    invertY: false,
    relativeInput: false
  });

  parallaxInstance.friction(0.2, 0.2);
};

export const initParallaxMobile = () => {
  const tabletBreakpoint = 767;
  if ($(window).width() > tabletBreakpoint) {
    const scene = $(".js-decorations-key-group");
    $(scene).each(function() {
      initParallaxDecorations($(this));
    });
  }
};

const showMoreAlternatives = () => {
  const cardsList = $(".cards-list"),
        cardsItem = $(".cards-list__item"),
        showMoreBtn = $(".js-show-more-items");

  if ( cardsList.length ) {
    cardsList.ready(function() {
      let i = 0;

      cardsItem.each(function() {
        let windowSize = $(window).width(),
            tabletBreakpoint = 640,
            desctopBreakpoint = 960;
        
        i += 1;

        if ( windowSize > desctopBreakpoint || windowSize < tabletBreakpoint ) {
          if (i > 13) {
            $(this).addClass(CLASSES.IS_HIDDEN);
          }
        } else if ( windowSize > tabletBreakpoint) {
          if (i > 12) {
            $(this).addClass(CLASSES.IS_HIDDEN);
          }
        };
      });

      if (cardsItem.length <= 13) {
        showMoreBtn.addClass(CLASSES.IS_HIDDEN);
      };
      
      $(".js-show-more-items").on("click", function() {
        let i = 0;
        
        $(".is-hidden").each(function() {
          i += 1;
          if (i <= 12) {
            $(this).removeClass(CLASSES.IS_HIDDEN);
          }
        });

        const cardsItemHidden = $(".cards-list__item.is-hidden");
        
        if (cardsItemHidden.length < 1) {
          showMoreBtn.addClass(CLASSES.IS_HIDDEN);
        }
      });
    });
  };
}

$(document).ready(function() {
  initWowLibrary();
  initParallaxMobile();
  showMoreAlternatives();
  checkWebpSupport();
  addedLazyLoadImages();
});